class SectionTextAside implements ng.IComponentController {
    ltTitle: string;
    text: string;
    relationList: string[];
    imageUrl: string;
}

angular.module('animatronApp.sectionTextAside', []).component('sectionTextAside', {
    bindings: {
        ltTitle: '<?',
        text: '<',
        relationList: '<?',
        imageUrl: '<?',
    },
    controller: SectionTextAside,
    templateUrl: require('landing-template/components/sections/section-text-aside.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionTextAside.ts